<template>
  <div class="flex flex-wrap flex-direction-column flex-clz">
    <div style="display: flex; align-items: center;">
      <el-button type="text" style="margin-right: 10px;" @click="goBack">
        <el-icon style="font-size: 25px;"><ArrowLeftBold/></el-icon>
      </el-button>
      <h2>{{ projectName }}</h2>
    </div>
    <div style="display: flex; align-items: center;">
      <p style="display: block;"> 建档于: {{ projectEstablishDate }}</p>
      <p style="display: block;"> 开工于: {{ projectStartDate }}</p>
      <p style="display: block;"> 环卫周期: {{ projectDuration }}天, 超出计划竣工: {{ projectOverdue }}天</p>
    </div>
    <div style="display: flex; align-items: center;">
      <p style="display: block;"> 项目来源: {{ projectResource }}</p>
      <p style="display: block;"> 维权公示牌: <a href="detail.html">查看详情</a></p>
    </div>
  </div>
  <div class="flex flex-wrap flex-direction-column flex-clz">
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane label="项目看板" name="projectBoard"><projectBoard/></el-tab-pane>
      <el-tab-pane label="花名册" name="roster"><rosterList/></el-tab-pane>
      <el-tab-pane label="班组管理" name="teamManagement"><workerGrpList/></el-tab-pane>
      <el-tab-pane label="参建单位" name="constructionUnits"><partConstrUnitsList/></el-tab-pane>
      <el-tab-pane label="工人考勤" name="workerAttendance"><workerAttdList/></el-tab-pane>
      <el-tab-pane label="工资发放" name="wagePayment"><salaryList/></el-tab-pane>
      <el-tab-pane label="工资专户" name="wageSpecialAccount"><specSalaryAcct/></el-tab-pane>
      <el-tab-pane label="拨付计划" name="allocationPlan"><apprPlan/></el-tab-pane>
      <el-tab-pane label="项目八大员" name="projectEightMembers"><eightKeyPerson/></el-tab-pane>
      <el-tab-pane label="工程款支付担保" name="projectPaymentGuarantee"><paymentBond/></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { ArrowLeftBold } from '@element-plus/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import projectBoard from './ProjectBoard.vue'
import apprPlan from './apprPlan.vue'
import eightKeyPerson from './eightKeyPerson.vue'
import partConstrUnitsList from './partConstrUnitsList.vue'
import paymentBond from './paymentBond.vue'
import rosterList from './rosterList.vue'
import salaryList from './salaryList.vue'
import specSalaryAcct from './specSalaryAcct.vue'
import workerAttdList from './workerAttdList.vue'
import workerGrpList from './workerGrpList.vue'
// 项目基本信息
const projectName = 'SN广场南侧地块一标段、二标段总承包工程';
const projectEstablishDate = '2021-07-02';
const projectStartDate = '2021-06-18';
const projectDuration = 1074;
const projectOverdue = 214;
const projectResource = "市监察";


const activeName = ref('projectBoard');
const route = useRoute();
const router = useRouter();
const goBack = () => {
  router.go(-1);
};
</script>

<style scoped>
.project-overview {
  margin-bottom: 20px;
}
.mb-4 {
  margin-bottom: 16px;
}

.col-style {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  margin: 5px;
  padding: 10px;
}
.col-inner-style {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  margin: 5px;
  padding: 10px;
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
}
.left-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.no-rating-badge {
  border: 1px solid #ccc;
  border-radius: 50%;
  padding: 10px;
  text-align: center;
}
.right-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

</style>

